export default "__VITE_ASSET__6651ac0b__"